import script from "./ExpertDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./ExpertDetail.vue?vue&type=script&setup=true&lang=js"

import "./index.css?vue&type=style&index=0&id=75224aae&scoped=true&lang=css&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75224aae"]])

export default __exports__